import React, { Component } from 'react';

import { PropTypes } from 'prop-types';
import { TransportAuthorityMapPoints } from './transportAuthorityMapPoints/TransportAuthorityMapPoints';
import { ProviderMapPoints } from './providerMapPoints/ProviderMapPoints';

export class MapPoints extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        selectedProvider: PropTypes.string
    }

    componentDidMount() {
        this.context.selectApp('datamanager', false);
    }

    // ----------------------

    isTransportAuthorityData() {
        const { selectedProvider } = this.context;

        return undefined !== selectedProvider && selectedProvider.startsWith("0:");
    }

    // ----------------------

    renderMapPoints() {
        if (this.isTransportAuthorityData()) {
            return <TransportAuthorityMapPoints title="Pontos Notáveis" />
        }

        return <ProviderMapPoints title="Pontos Notáveis" />
    }

    render() {
        return (
            <div>
                {this.renderMapPoints()}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/mapPoints/MapPoints.js